/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Echo the local attempt identity; no browser-provided proof, status or native identity.
 * @export
 * @interface FlightExchangeAuthenticationRefreshRequest
 */
export interface FlightExchangeAuthenticationRefreshRequest {
  /**
   *
   * @type {string}
   * @memberof FlightExchangeAuthenticationRefreshRequest
   */
  authenticationId: string;
}

/**
 * Check if a given object implements the FlightExchangeAuthenticationRefreshRequest interface.
 */
export function instanceOfFlightExchangeAuthenticationRefreshRequest(
  value: object
): value is FlightExchangeAuthenticationRefreshRequest {
  if (!("authenticationId" in value) || value["authenticationId"] === undefined)
    return false;
  return true;
}

export function FlightExchangeAuthenticationRefreshRequestFromJSON(
  json: any
): FlightExchangeAuthenticationRefreshRequest {
  return FlightExchangeAuthenticationRefreshRequestFromJSONTyped(json, false);
}

export function FlightExchangeAuthenticationRefreshRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightExchangeAuthenticationRefreshRequest {
  if (json == null) {
    return json;
  }
  return {
    authenticationId: json["authentication_id"],
  };
}

export function FlightExchangeAuthenticationRefreshRequestToJSON(
  json: any
): FlightExchangeAuthenticationRefreshRequest {
  return FlightExchangeAuthenticationRefreshRequestToJSONTyped(json, false);
}

export function FlightExchangeAuthenticationRefreshRequestToJSONTyped(
  value?: FlightExchangeAuthenticationRefreshRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    authentication_id: value["authenticationId"],
  };
}
